import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// axios.defaults.xsrfCookieName = "csrftoken";
// axios.defaults.xsrfHeaderName = "X-CSRFToken";
// axios.defaults.withCredentials = true;

function Gmac() {
    const [gType, setGType] = useState("1");
    const [gName, setGName] = useState("0");
    const navigate = useNavigate();
    const id = window.localStorage.getItem("id");
    const token = window.localStorage.getItem("token");

    const GmacAdding = () => {
        axios
            .post(
                "http://tagard.in:8005/influx/mqtt/",
                {
                    userNid: id,
                    mqtt: gName,
                    gmacType: gType,
                },
                {
                    headers: {
                        Accept: "text/html; q=1.0, */*",
                        "Accept-Language": "en-US,en;q=0.5",
                        "Accept-Encoding": "gzip, deflate, br",
                        "X-CSRFTOKEN": token,
                        "Sec-Fetch-Dest": "empty",
                        "Sec-Fetch-Mode": "cors",
                        "Sec-Fetch-Site": "same-origin",
                    },
                }
            )
            .then((res) => {
                // console.log(res.data);
                navigate("/");
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <>
            <h1 className="ml-10 mt-5 w-50  h-100">Gmac</h1>
            <form>
                <div className="pb-3">
                    <label style={{ marginRight: 20 }}>Gmat Types</label>
                    <select onChange={(e) => setGType(e.target.value)}>
                        <option value="1">TAG01</option>
                        <option value="2">TAG02</option>
                        <option value="3">TAG03</option>
                        <option value="107">TAG0107</option>
                        <option value="107Pro">TAG107Pro</option>
                        <option value="117">TAG117</option>
                    </select>
                </div>
                <div className="pb-3">
                    <label style={{ marginRight: 18 }}>Gmac Name</label>
                    <input
                        placeholder="Type the Gmac"
                        onChange={(e) => setGName(e.target.value)}
                    ></input>
                </div>
                <button
                    type="button"
                    style={{ height: 50, width: 200 }}
                    onClick={GmacAdding}
                ></button>
            </form>
        </>
    );
}

export default Gmac;
